import { STATE_NAME } from "./taxYear.constants";

export const getState = state => state[STATE_NAME];

export const getTaxYear = state => state[STATE_NAME].taxYear;

export const getTaxTable = state => state[STATE_NAME].taxTable;
